import { Container } from '@mui/material';
import Navbar from '../../../../components/shared-menu/Navbar';
import CreateEnquiryForm from './CreateEnquiryForm';

export default function CreateEnquiryPage(props) {
	return (
   <>
  			<Navbar />

  			<Container sx={{ my: '2rem' }}>
  				<CreateEnquiryForm />
  			</Container>
	
   </>
 );
}
